import { Component, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { BasicAuthService } from '../../../../../services/basic-auth.service'
import { MenuTopSecondNotifyService } from './menu-top-second-notify.service'
import { InstalledModule } from '../../../../../models/login-response.model'
import { TopMenuService } from '../../../../../services/ui-components/top-menu.service'
import { TopMenuItem } from '../../../../../services/ui-components/menu.service.config'

@Component({
  selector: 'app-menu-top-second',
  templateUrl: './menu-top-second.component.html',
  standalone: false,
})
export class MenuTopSecondComponent implements OnInit, OnDestroy {
  private readonly role: string
  private readonly modules: InstalledModule[] = []
  private _subscription: Subscription
  private _items: TopMenuItem[] = []

  public get items(): TopMenuItem[] {
    return this._items
  }

  constructor(
    private service: TopMenuService,
    private basicAuthService: BasicAuthService,
    private notifyService: MenuTopSecondNotifyService,
  ) {
    this.role = this.basicAuthService.getUserRole()
    this.modules = this.basicAuthService.getModules()
  }

  public hasAccess(item: TopMenuItem): boolean {
    return this.service.hasAccessToItemByRole(item, this.role)
      && this.service.hasAccessToItemByModules(item, this.modules)
  }

  public display(item: TopMenuItem): boolean {
    return item._display ?? true
  }

  ngOnInit(): void {
    this._subscription = this.notifyService.changeMenuEventEmitter.subscribe({
      next: (result: any[]): void => {
        this._items = result
      },
      error: (error) => (this._items = []),
    })
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe()
  }
}
